import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "원격 캐싱",
  "description": "머신 간에 캐시 아티팩트를 공유하여 더 빠른 빌드를 구현합니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo의 태스크 캐시는 동일한 작업을 두 번 수행하지 않음으로써 시간을 절약합니다."
  }, {
    "heading": "",
    "content": "하지만 문제가 있습니다: 캐시는 로컬 머신에만 저장됩니다. 지속적 통합(CI) 시스템을 사용할 때 이로 인해 많은 중복 작업이 발생할 수 있습니다:"
  }, {
    "heading": "",
    "content": "Turborepo는 기본적으로 로컬 파일시스템에만 캐시하기 때문에, 동일한 태스크(turbo run build)가 모든 태스크 입력이 동일하더라도 각 머신에서 다시 실행되어야 합니다(개발자, 팀원, CI, PaaS 등에 의해) — 이는 시간과 리소스를 낭비합니다."
  }, {
    "heading": "",
    "content": "Turborepo를 사용하기 위해 원격 캐싱을 사용할 필요는 없습니다. 원격 캐싱이 가장\n큰 속도 향상을 가져오지만, 원격 캐싱 없이도 기존 워크플로우를 더 빠르게 만들\n수 있습니다."
  }, {
    "heading": "단일-공유-캐시",
    "content": "팀 전체(심지어 CI까지)에서 단일 Turborepo 캐시를 공유할 수 있다면 어떨까요?"
  }, {
    "heading": "단일-공유-캐시",
    "content": "Turborepo는 태스크 결과를 저장하는 클라우드 서버인 원격 캐시와 안전하게 통신할 수 있습니다. 이를 통해 조직 전체에서 중복 작업을 방지하여 엄청난 시간을 절약할 수 있습니다."
  }, {
    "heading": "단일-공유-캐시",
    "content": "원격 캐싱은 무료이며 관리형 제공업체 또는 자체 호스팅 캐시와 함께 사용할 수 있습니다."
  }, {
    "heading": "단일-공유-캐시",
    "content": "원격 캐싱은 Turborepo의 강력한 기능이지만, 큰 힘에는 큰 책임이 따릅니다. 먼저\n올바르게 캐싱하고 있는지 확인하고 환경 변수\n처리를 다시\n확인하세요. Turborepo는 로그를 아티팩트로 취급하므로 콘솔에 무엇을 출력하는지\n주의하세요."
  }, {
    "heading": "vercel",
    "content": "Vercel 원격 캐시는 Vercel에서 애플리케이션을 호스팅하지 않더라도 모든 플랜에서 무료로 사용할 수 있습니다. 아래 단계에 따라 리포지토리에 대한 원격 캐싱을 활성화하세요."
  }, {
    "heading": "로컬-개발의-경우",
    "content": "로컬 Turborepo를 원격 캐시에 연결하려면 Turborepo CLI를 Vercel 계정으로 인증하세요:"
  }, {
    "heading": "로컬-개발의-경우",
    "content": "전역 turbo가 설치되어 있지 않은 경우 패키지 매니저를 사용할 수도 있습니다:"
  }, {
    "heading": "로컬-개발의-경우",
    "content": "원격 캐시가 Single Sign-On을 사용하도록 구성된 경우 올바른 권한이 있는 캐시\n토큰을 얻으려면 npx turbo login --sso-team=team-name을 실행해야 합니다."
  }, {
    "heading": "로컬-개발의-경우",
    "content": "이제 Turborepo를 원격 캐시에 연결합니다:"
  }, {
    "heading": "로컬-개발의-경우",
    "content": "활성화되면 현재 캐싱 중인 패키지를 변경하고 turbo run을 사용하여 태스크를 실행하세요.\n이제 캐시 아티팩트가 로컬 및 원격 캐시에 저장됩니다."
  }, {
    "heading": "로컬-개발의-경우",
    "content": "확인하려면 다음을 사용하여 로컬 Turborepo 캐시를 삭제하세요:"
  }, {
    "heading": "로컬-개발의-경우",
    "content": "그런 다음 동일한 빌드를 다시 실행하세요. 제대로 작동한다면 turbo는 로컬에서 태스크를 실행하지 않아야 합니다. 대신 원격 캐시에서 로그와 아티팩트를 다운로드하여 재생합니다."
  }, {
    "heading": "vercel에서의-원격-캐싱",
    "content": "Vercel에서 앱을 빌드하고 호스팅하는 경우, turbo를 사용하면 원격 캐싱이 자동으로 설정됩니다. 자세한 내용은 Vercel 문서를 참조하세요."
  }, {
    "heading": "아티팩트-무결성-및-진위성-검증",
    "content": "Turborepo는 원격 캐시에 업로드하기 전에 비밀 키로 아티팩트에 서명할 수 있습니다. Turborepo는 제공된 비밀 키를 사용하여 아티팩트에 HMAC-SHA256 서명을 사용합니다.\nTurborepo는 다운로드할 때 원격 캐시 아티팩트의 무결성과 진위성을 검증합니다.\n검증에 실패한 아티팩트는 무시되고 Turborepo에서 캐시 미스로 처리됩니다."
  }, {
    "heading": "아티팩트-무결성-및-진위성-검증",
    "content": "이 기능을 활성화하려면 turbo.json 구성의 remoteCache 옵션을 signature: true로 설정하세요. 그런 다음 TURBO_REMOTE_CACHE_SIGNATURE_KEY 환경 변수를 선언하여 비밀 키를 지정하세요."
  }, {
    "heading": "원격-캐시-api",
    "content": "원격 캐시는 Turborepo의 원격 캐싱 API 사양을 충족하는 모든 HTTP 서버로 구현할 수 있습니다."
  }, {
    "heading": "vercel의-관리형-원격-캐시",
    "content": "Turborepo의 제작자이자 유지 관리자인 Vercel은 Turborepo와 완전히 호환되는 관리형 원격 캐시를 제공합니다."
  }, {
    "heading": "vercel의-관리형-원격-캐시",
    "content": "Vercel 원격 캐시를 사용하면 구성이 필요 없으며 오픈 소스 Vercel 원격 캐시 SDK를 통해 Vercel 배포와 자동으로 통합됩니다."
  }, {
    "heading": "vercel의-관리형-원격-캐시",
    "content": "Vercel의 Turborepo에 대해 자세히 알아보거나 무료로 템플릿을 배포하여 사용해 보세요."
  }, {
    "heading": "자체-호스팅",
    "content": "자체 호스팅 원격 캐시를 사용하고 --manual 플래그를 사용하여 로그인하여 API URL, 팀 및 토큰 정보를 제공할 수도 있습니다."
  }, {
    "heading": "openapi-사양",
    "content": "사람이 읽을 수 있는 뷰어"
  }, {
    "heading": "openapi-사양",
    "content": "JSON"
  }, {
    "heading": "openapi-사양",
    "content": "현재 모든 버전의 turbo는 v8 엔드포인트와 호환됩니다."
  }, {
    "heading": "커뮤니티-구현",
    "content": "Turborepo 커뮤니티는 원격 캐시의 오픈 소스 구현을 만들었습니다."
  }, {
    "heading": "커뮤니티-구현",
    "content": "brunojppb/turbo-cache-server"
  }, {
    "heading": "커뮤니티-구현",
    "content": "ducktors/turborepo-remote-cache"
  }, {
    "heading": "커뮤니티-구현",
    "content": "Tapico/tapico-turborepo-remote-cache"
  }],
  "headings": [{
    "id": "단일-공유-캐시",
    "content": "단일 공유 캐시"
  }, {
    "id": "vercel",
    "content": "Vercel"
  }, {
    "id": "로컬-개발의-경우",
    "content": "로컬 개발의 경우"
  }, {
    "id": "vercel에서의-원격-캐싱",
    "content": "Vercel에서의 원격 캐싱"
  }, {
    "id": "아티팩트-무결성-및-진위성-검증",
    "content": "아티팩트 무결성 및 진위성 검증"
  }, {
    "id": "원격-캐시-api",
    "content": "원격 캐시 API"
  }, {
    "id": "vercel의-관리형-원격-캐시",
    "content": "Vercel의 관리형 원격 캐시"
  }, {
    "id": "자체-호스팅",
    "content": "자체 호스팅"
  }, {
    "id": "openapi-사양",
    "content": "OpenAPI 사양"
  }, {
    "id": "커뮤니티-구현",
    "content": "커뮤니티 구현"
  }]
};
import {Callout} from '#components/callout';
import {PlatformTabs, PackageManagerTabs, Tab} from '#components/tabs';
import {ThemeAwareImage} from '#components/theme-aware-image';
export const toc = [{
  depth: 2,
  url: "#단일-공유-캐시",
  title: _jsx(_Fragment, {
    children: "단일 공유 캐시"
  })
}, {
  depth: 2,
  url: "#vercel",
  title: _jsx(_Fragment, {
    children: "Vercel"
  })
}, {
  depth: 3,
  url: "#로컬-개발의-경우",
  title: _jsx(_Fragment, {
    children: "로컬 개발의 경우"
  })
}, {
  depth: 3,
  url: "#vercel에서의-원격-캐싱",
  title: _jsx(_Fragment, {
    children: "Vercel에서의 원격 캐싱"
  })
}, {
  depth: 3,
  url: "#아티팩트-무결성-및-진위성-검증",
  title: _jsx(_Fragment, {
    children: "아티팩트 무결성 및 진위성 검증"
  })
}, {
  depth: 2,
  url: "#원격-캐시-api",
  title: _jsx(_Fragment, {
    children: "원격 캐시 API"
  })
}, {
  depth: 3,
  url: "#vercel의-관리형-원격-캐시",
  title: _jsx(_Fragment, {
    children: "Vercel의 관리형 원격 캐시"
  })
}, {
  depth: 3,
  url: "#자체-호스팅",
  title: _jsx(_Fragment, {
    children: "자체 호스팅"
  })
}, {
  depth: 4,
  url: "#openapi-사양",
  title: _jsx(_Fragment, {
    children: "OpenAPI 사양"
  })
}, {
  depth: 4,
  url: "#커뮤니티-구현",
  title: _jsx(_Fragment, {
    children: "커뮤니티 구현"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo의 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "태스크 캐시"
      }), "는 동일한 작업을 두 번 수행하지 않음으로써 시간을 절약합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["하지만 문제가 있습니다: ", _jsx(_components.strong, {
        children: "캐시는 로컬 머신에만 저장됩니다"
      }), ". 지속적 통합(CI) 시스템을 사용할 때 이로 인해 많은 중복 작업이 발생할 수 있습니다:"]
    }), "\n", _jsx(ThemeAwareImage, {
      dark: {
        alt: 'Local caching creates a cache on each system.',
        src: '/images/docs/local-caching-dark.png',
        props: {
          width: 896,
          height: 345
        }
      },
      light: {
        alt: 'Local caching creates a cache on each system.',
        src: '/images/docs/local-caching-light.png',
        props: {
          width: 896,
          height: 345
        }
      }
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 기본적으로 로컬 파일시스템에만 캐시하기 때문에, 동일한 태스크(", _jsx(_components.code, {
        children: "turbo run build"
      }), ")가 모든 태스크 입력이 동일하더라도 ", _jsx(_components.strong, {
        children: "각 머신에서 다시 실행"
      }), "되어야 합니다(개발자, 팀원, CI, PaaS 등에 의해) — 이는 ", _jsx(_components.strong, {
        children: "시간과 리소스를 낭비"
      }), "합니다."]
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsx(_components.p, {
        children: "Turborepo를 사용하기 위해 원격 캐싱을 사용할 필요는 없습니다. 원격 캐싱이 가장\n큰 속도 향상을 가져오지만, 원격 캐싱 없이도 기존 워크플로우를 더 빠르게 만들\n수 있습니다."
      })
    }), "\n", _jsx(_components.h2, {
      id: "단일-공유-캐시",
      children: "단일 공유 캐시"
    }), "\n", _jsx(_components.p, {
      children: "팀 전체(심지어 CI까지)에서 단일 Turborepo 캐시를 공유할 수 있다면 어떨까요?"
    }), "\n", _jsx(ThemeAwareImage, {
      dark: {
        alt: 'Remote caching creates a shared cache for your entire team.',
        src: '/images/docs/remote-caching-dark.png',
        props: {
          width: 896,
          height: 489
        }
      },
      light: {
        alt: 'Remote caching creates a shared cache for your entire team.',
        src: '/images/docs/remote-caching-light.png',
        props: {
          width: 896,
          height: 489
        }
      }
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 태스크 결과를 저장하는 클라우드 서버인 원격 캐시와 안전하게 통신할 수 있습니다. 이를 통해 ", _jsx(_components.strong, {
        children: "조직 전체에서 중복 작업을 방지"
      }), "하여 엄청난 시간을 절약할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["원격 캐싱은 무료이며 ", _jsx(_components.a, {
        href: "https://turborepo.com/docs/core-concepts/remote-caching#managed-remote-cache-with-vercel",
        children: "관리형 제공업체"
      }), " 또는 ", _jsx(_components.a, {
        href: "https://turborepo.com/docs/core-concepts/remote-caching#self-hosting",
        children: "자체 호스팅 캐시"
      }), "와 함께 사용할 수 있습니다."]
    }), "\n", _jsx(Callout, {
      children: _jsxs(_components.p, {
        children: ["원격 캐싱은 Turborepo의 강력한 기능이지만, 큰 힘에는 큰 책임이 따릅니다. 먼저\n올바르게 캐싱하고 있는지 확인하고 ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/using-environment-variables",
          children: "환경 변수\n처리"
        }), "를 다시\n확인하세요. Turborepo는 로그를 아티팩트로 취급하므로 콘솔에 무엇을 출력하는지\n주의하세요."]
      })
    }), "\n", _jsx(_components.h2, {
      id: "vercel",
      children: "Vercel"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/remote-caching",
        children: "Vercel 원격 캐시"
      }), "는 Vercel에서 애플리케이션을 호스팅하지 않더라도 모든 플랜에서 무료로 사용할 수 있습니다. 아래 단계에 따라 리포지토리에 대한 원격 캐싱을 활성화하세요."]
    }), "\n", _jsx(_components.h3, {
      id: "로컬-개발의-경우",
      children: "로컬 개발의 경우"
    }), "\n", _jsx(_components.p, {
      children: "로컬 Turborepo를 원격 캐시에 연결하려면 Turborepo CLI를 Vercel 계정으로 인증하세요:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/getting-started/installation#global-installation",
        children: ["전역 ", _jsx(_components.code, {
          children: "turbo"
        })]
      }), "가 설치되어 있지 않은 경우 패키지 매니저를 사용할 수도 있습니다:"]
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " login"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dlx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " login"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " login"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun (Beta)",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bunx"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " turbo"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " login"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsx(Callout, {
      children: _jsxs(_components.p, {
        children: ["원격 캐시가 Single Sign-On을 사용하도록 구성된 경우 올바른 권한이 있는 캐시\n토큰을 얻으려면 ", _jsx(_components.code, {
          children: "npx turbo login --sso-team=team-name"
        }), "을 실행해야 합니다."]
      })
    }), "\n", _jsx(_components.p, {
      children: "이제 Turborepo를 원격 캐시에 연결합니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " link"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["활성화되면 현재 캐싱 중인 패키지를 변경하고 ", _jsx(_components.code, {
        children: "turbo run"
      }), "을 사용하여 태스크를 실행하세요.\n이제 캐시 아티팩트가 로컬 ", _jsx(_components.em, {
        children: "및"
      }), " 원격 캐시에 저장됩니다."]
    }), "\n", _jsx(_components.p, {
      children: "확인하려면 다음을 사용하여 로컬 Turborepo 캐시를 삭제하세요:"
    }), "\n", _jsxs(PlatformTabs, {
      children: [_jsx(Tab, {
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "rm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " -rf"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " ./.turbo/cache"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "rd"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " /s"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " /q"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"./.turbo/cache\""
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["그런 다음 동일한 빌드를 다시 실행하세요. 제대로 작동한다면 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 로컬에서 태스크를 실행하지 않아야 합니다. 대신 원격 캐시에서 로그와 아티팩트를 다운로드하여 재생합니다."]
    }), "\n", _jsx(_components.h3, {
      id: "vercel에서의-원격-캐싱",
      children: "Vercel에서의 원격 캐싱"
    }), "\n", _jsxs(_components.p, {
      children: ["Vercel에서 앱을 빌드하고 호스팅하는 경우, ", _jsx(_components.code, {
        children: "turbo"
      }), "를 사용하면 원격 캐싱이 자동으로 설정됩니다. 자세한 내용은 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/concepts/monorepos/remote-caching?utm_source=turborepo.com&utm_medium=referral&utm_campaign=docs-link",
        children: "Vercel 문서"
      }), "를 참조하세요."]
    }), "\n", _jsx(_components.h3, {
      id: "아티팩트-무결성-및-진위성-검증",
      children: "아티팩트 무결성 및 진위성 검증"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 원격 캐시에 업로드하기 전에 비밀 키로 아티팩트에 서명할 수 있습니다. Turborepo는 제공된 비밀 키를 사용하여 아티팩트에 ", _jsx(_components.code, {
        children: "HMAC-SHA256"
      }), " 서명을 사용합니다.\nTurborepo는 다운로드할 때 원격 캐시 아티팩트의 무결성과 진위성을 검증합니다.\n검증에 실패한 아티팩트는 무시되고 Turborepo에서 캐시 미스로 처리됩니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이 기능을 활성화하려면 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 구성의 ", _jsx(_components.code, {
        children: "remoteCache"
      }), " 옵션을 ", _jsx(_components.code, {
        children: "signature: true"
      }), "로 설정하세요. 그런 다음 ", _jsx(_components.code, {
        children: "TURBO_REMOTE_CACHE_SIGNATURE_KEY"
      }), " 환경 변수를 선언하여 비밀 키를 지정하세요."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables has-highlighted",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"remoteCache\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line highlighted",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"signature\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " true"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h2, {
      id: "원격-캐시-api",
      children: "원격 캐시 API"
    }), "\n", _jsx(_components.p, {
      children: "원격 캐시는 Turborepo의 원격 캐싱 API 사양을 충족하는 모든 HTTP 서버로 구현할 수 있습니다."
    }), "\n", _jsx(_components.h3, {
      id: "vercel의-관리형-원격-캐시",
      children: "Vercel의 관리형 원격 캐시"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo의 제작자이자 유지 관리자인 ", _jsx(_components.a, {
        href: "https://vercel.com",
        children: "Vercel"
      }), "은 Turborepo와 완전히 호환되는 관리형 원격 캐시를 제공합니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/remote-caching",
        children: "Vercel 원격 캐시"
      }), "를 사용하면 구성이 필요 없으며 오픈 소스 ", _jsx(_components.a, {
        href: "https://github.com/vercel/remote-cache",
        children: "Vercel 원격 캐시 SDK"
      }), "를 통해 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/deployments/overview",
        children: "Vercel 배포"
      }), "와 자동으로 통합됩니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/turborepo",
        children: "Vercel의 Turborepo"
      }), "에 대해 자세히 알아보거나 ", _jsx(_components.a, {
        href: "https://vercel.com/templates?search=turborepo",
        children: "무료로 템플릿을 배포"
      }), "하여 사용해 보세요."]
    }), "\n", _jsx(_components.h3, {
      id: "자체-호스팅",
      children: "자체 호스팅"
    }), "\n", _jsxs(_components.p, {
      children: ["자체 호스팅 원격 캐시를 사용하고 ", _jsx(_components.code, {
        children: "--manual"
      }), " 플래그를 사용하여 로그인하여 API URL, 팀 및 토큰 정보를 제공할 수도 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " login"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --manual"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h4, {
      id: "openapi-사양",
      children: "OpenAPI 사양"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/docs/openapi",
          children: "사람이 읽을 수 있는 뷰어"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "/api/remote-cache-spec",
          children: "JSON"
        })
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["현재 모든 버전의 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 ", _jsx(_components.code, {
        children: "v8"
      }), " 엔드포인트와 호환됩니다."]
    }), "\n", _jsx(_components.h4, {
      id: "커뮤니티-구현",
      children: "커뮤니티 구현"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 커뮤니티는 원격 캐시의 오픈 소스 구현을 만들었습니다."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/brunojppb/turbo-cache-server",
          children: _jsx(_components.code, {
            children: "brunojppb/turbo-cache-server"
          })
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/ducktors/turborepo-remote-cache",
          children: _jsx(_components.code, {
            children: "ducktors/turborepo-remote-cache"
          })
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/Tapico/tapico-turborepo-remote-cache",
          children: _jsx(_components.code, {
            children: "Tapico/tapico-turborepo-remote-cache"
          })
        })
      }), "\n"]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
